module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-4",
    attrs: {
      "flat": "",
      "height": "100%"
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.req
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.statementRequest,
      "message200": false
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-0 px-1"
  }, [(_vm.practitionerId) ? _c('v-chip', {
    attrs: {
      "label": ""
    }
  }, [_vm._v(_vm._s(_vm.getPractitionerById(_vm.practitionerId).full_name) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.success) ? _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary",
      "disabled": _vm.statementRequest.loading || !_vm.hasCreateInvoicePermissions || !_vm.metaIsValid || !_vm.hasAppointments,
      "loading": _vm.req.loading
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("\n      Create invoice\n    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.title) ? [_c('v-card-title', {
    staticClass: "overline grey lighten-4 py-0"
  }, [_c('v-btn', {
    staticClass: "ml-1 pl-0",
    attrs: {
      "small": "",
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("post_add")])], 1), _vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.success) ? _c('invoice-success', _vm._g({
    model: {
      value: (_vm.remoteInvoice),
      callback: function($$v) {
        _vm.remoteInvoice = $$v
      },
      expression: "remoteInvoice"
    }
  }, _vm.$listeners)) : [(_vm.statementRequest && _vm.hasCreateInvoicePermissions) ? _c('invoice-billing-details', {
    staticClass: "ma-2 elevation-2",
    attrs: {
      "expanded": false,
      "request": _vm.statementRequest,
      "settings": _vm.spaceSettings
    },
    on: {
      "update:settings": [function($event) {
        _vm.spaceSettings = $event
      }, _vm.setSpaceSettings]
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0 pt-0"
  }, [_c('v-text-field', {
    staticClass: "pb-0 mb-0",
    attrs: {
      "label": "Invoice name"
    },
    model: {
      value: (_vm.invoice.title),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "title", $$v)
      },
      expression: "invoice.title"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dialog",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.showDatepicker),
      callback: function($$v) {
        _vm.showDatepicker = $$v
      },
      expression: "showDatepicker"
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0 mb-0 mr-2",
    attrs: {
      "slot": "activator",
      "label": "Invoice date",
      "readonly": "",
      "append-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.invoice.date),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "date", $$v)
      },
      expression: "invoice.date"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "flat": "",
      "tile": "",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.showDatepicker = false
      }
    },
    model: {
      value: (_vm.invoice.date),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "date", $$v)
      },
      expression: "invoice.date"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showDatepicker = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dialog",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.showDueDatepicker),
      callback: function($$v) {
        _vm.showDueDatepicker = $$v
      },
      expression: "showDueDatepicker"
    }
  }, [_c('v-text-field', {
    staticClass: "pb-0 mb-0",
    attrs: {
      "slot": "activator",
      "label": "Invoice due date",
      "readonly": "",
      "append-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.invoice.due_date),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "due_date", $$v)
      },
      expression: "invoice.due_date"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "flat": "",
      "no-title": "",
      "min": _vm.invoice.date,
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.showDueDatepicker = false
      }
    },
    model: {
      value: (_vm.invoice.due_date),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "due_date", $$v)
      },
      expression: "invoice.due_date"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showDueDatepicker = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.invoice.due_date < _vm.latestDate) ? _c('v-alert', {
    staticClass: "pa-1 ma-0 caption",
    attrs: {
      "outline": "",
      "dismissible": "",
      "value": true,
      "type": "warning"
    }
  }, [_vm._v("\n          You have selected a due date earlier than the latest appointment included on this invoice"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("You can still create the invoice, we just wanted to let you know")])]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.hasAppointments) ? _c('v-list', {
    staticClass: "ma-0",
    attrs: {
      "dense": "",
      "three-line": ""
    }
  }, [_c('v-list-group', [_c('v-subheader', {
    staticClass: "overline",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("person")]), _vm._v("\n          " + _vm._s(_vm.fullname) + "\n        ")], 1), _vm._v(" "), (_vm.relationshipId) ? _c('client-card', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "flat": "",
      "with-client-name": false,
      "relationship-id": _vm.relationshipId
    },
    on: {
      "relationship": _vm.setRelationship
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-group', [_c('v-subheader', {
    staticClass: "overline",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [(_vm.password) ? _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "amber"
    }
  }, [_vm._v("lock")]) : _c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "info"
    }
  }, [_vm._v("lock_open")]), _vm._v("\n          Password protect\n        ")], 1), _vm._v(" "), _c('encrypt-invoice', {
    attrs: {
      "password": _vm.password,
      "password-hint": _vm.passwordHint,
      "relationship": _vm.rel
    },
    on: {
      "update:password": function($event) {
        _vm.password = $event
      },
      "update:passwordHint": function($event) {
        _vm.passwordHint = $event
      },
      "update:password-hint": function($event) {
        _vm.passwordHint = $event
      }
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.computedInvoice && _vm.computedInvoice.appointments) ? _c('read-only-statement-list', {
    attrs: {
      "flat": "",
      "debounce": "",
      "initially-collapsed": true,
      "due": _vm.finaldue,
      "with-edit": _vm.withEdit,
      "appointment-ids": _vm.computedInvoice.appointments
    },
    on: {
      "update:due": function($event) {
        _vm.finaldue = $event
      },
      "edit": _vm.editInvoiceDetails,
      "remove": _vm.removeAppointment
    },
    model: {
      value: (_vm.statementRequest),
      callback: function($$v) {
        _vm.statementRequest = $$v
      },
      expression: "statementRequest"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.finaldue && _vm.finaldue > 0) ? [_c('div', {
    staticClass: "px-3 mb-3"
  }, [_c('v-checkbox', {
    staticClass: "caption",
    attrs: {
      "label": "Mark as paid",
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: (_vm.markPaid),
      callback: function($$v) {
        _vm.markPaid = $$v
      },
      expression: "markPaid"
    }
  }), _vm._v(" "), (_vm.markPaid) ? _c('payment-method-picker', {
    attrs: {
      "small": ""
    },
    model: {
      value: (_vm.paymentMethod),
      callback: function($$v) {
        _vm.paymentMethod = $$v
      },
      expression: "paymentMethod"
    }
  }) : _vm._e()], 1)] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.ready) ? [_c('transition', {
    attrs: {
      "name": "delay-display-none"
    }
  }, [(!_vm.metaIsValid) ? _c('v-alert', {
    staticClass: "pa-1 my-0",
    attrs: {
      "type": "warning",
      "dense": "",
      "value": true
    }
  }, [_vm._v("\n          Some information required to create an invoice is missing.\n          "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.relationship.loading || _vm.requests.appt.loading
    },
    on: {
      "click": _vm.fetchMeta
    }
  }, [_vm._v("Fetch data from server")])], 1) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (!_vm.hasAppointments) ? _c('div', {
    staticClass: "warning--text caption px-3"
  }, [_c('v-icon', {
    staticClass: "warning--text",
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n      No appointments selected\n    ")], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', {
    class: _vm.mobileCardActionsClasses,
    style: (_vm.mobileCardActionsStyles)
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.statementRequest.loading || !_vm.hasCreateInvoicePermissions || !_vm.metaIsValid || !_vm.hasAppointments,
      "loading": _vm.req.loading,
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("\n        Create Invoice\n      ")])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": !_vm.hasCreateInvoicePermissions
    }
  }, [_vm._v("\n      You do not have permission to create invoices in this space or spaces\n    ")])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4353dda6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/manage/create/confirm.vue
// module id = 1407
// module chunks = 9